// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/yasno/stylesheet/index.scss
 ** module id = 469
 ** module chunks = 1
 **/